import config from "../config/";
import {
    SET_RESOURCES,
    SET_ACTIVE_RESOURCE,
    LOADING_RESOURCES,
    SET_SKILLS,
    SET_SKILLS_VIDEOS,
    SET_NO_VIDEO_MESSAGE,
    HIDE_VIDEO_MESSAGE,
    UPDATE_OCCUPATION_SKILL,
    SET_ONLINE_COURSES,
    LOADING_ONLINE_COURSES,
    SET_HELP_VIDEOS,
    SET_SKILLS_ASSESSMENTS,
    SET_SKILLS_ASSESSMENTS_ERRORS,
    FETCH_SKILL_TYPES
} from "./types";
import { Cache } from "aws-amplify/utils";
import { post, get } from "./api";

export const viewedResource = (resource) => async (dispatch) => {
    try {
    //   // NO Response implemented yet
      await post("/jobitems/resource/viewed", {
        resourceId: resource.id,
        title: resource.title,
        link: resource.link
      });
    } catch (error) {
      console.log(error);
      // TODO
    }
};


export const addResourceSkill = (skill, job) => async (dispatch, getState) => {
    try {
        //   // NO Response implemented yet
          const occ = await post("/users/addResourceSkill", { skill: skill });
          if (occ && occ.data && occ.data && occ.data.occupationSkills){
            dispatch({ type: SET_SKILLS, skill: skill, occupationSkills: occ.data.occupationSkills });
          }
        } catch (error) {
          console.log(error);
          // TODO
        }
    // TODO
    dispatch({type: UPDATE_OCCUPATION_SKILL, job: job, skillName: skill})

    Cache.removeItem("jobCategories");

}
export const setActiveVideo = (resource) => async (dispatch) => {
    dispatch({type: SET_ACTIVE_RESOURCE, "resource": resource})
};

export const hideVideoMessage = (resource) => async (dispatch) => {
    dispatch({type: HIDE_VIDEO_MESSAGE})
}

export const getSkillVideos = (skillName) => async (dispatch, getState) => {
    try{
        const { data } = await post("/data/skills/videos", { "skill": skillName });

        if (data.video_suggestions && data.video_suggestions.length > 0) {
            dispatch({type: SET_SKILLS_VIDEOS,"videos": data, "skillName": skillName})
        } else {
            dispatch({type: SET_NO_VIDEO_MESSAGE, "videos": [], "skillName": skillName})
        }
    }
    catch(error) {
        console.log(error);
        dispatch({type: SET_NO_VIDEO_MESSAGE, "videos": [], "skillName": skillName})
    }
}





export const getOnlineCourses = () => async (dispatch, getState) => {
    try {

        const {
            jobs: {
                rawJobCategories:{
                    desired_occupations = [],
                    interest_occupations = [],
                    past_occupations = [],
                    searched_occupations = [],
                    skills_backpack_occupations = [],
                    styles_occupations = []
                }
            } 
        } = getState();
    
        let occupations = [];
        let categoryKey = {}
        searched_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Searched"
        })
        desired_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Preferred"
        });
        past_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Previous"
        })
        skills_backpack_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Skills"
        });
        interest_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Interest"
        })        
        styles_occupations.forEach((index) => {
            occupations.push(index.occupation);
            categoryKey[index.occupation] = "Styles"
        });
    
    dispatch({type: LOADING_ONLINE_COURSES, loading: true});

    const { data } = await post("/data/occupations/mooc", { "occupations": occupations });

    dispatch({type: SET_ONLINE_COURSES, data: data, orderDict: occupations, categoryKey: categoryKey});
    dispatch({type: LOADING_ONLINE_COURSES, loading: false});


    } catch (error) {
        console.log(error);
        // TODO
    }

    
}

export const getVideos = () => async (dispatch, getState) => {
    try {
        
    const {
        jobs: {
            rawJobCategories:{
                desired_occupations = [],
                interest_occupations = [],
                past_occupations = [],
                searched_occupations = [],
                skills_backpack_occupations = [],
                styles_occupations = []
            }
        } 
    } = getState();

    let occupations = [];
    let categoryKey = {}
    searched_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Searched"
    })
    desired_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Preferred"
    });
    past_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Previous"
    })
    skills_backpack_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Skills"
    });
    interest_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Interest"
    })        
    styles_occupations.forEach((index) => {
        occupations.push(index.occupation);
        categoryKey[index.occupation] = "Styles"
    });

    dispatch({type: LOADING_RESOURCES, loading: true});

    const { data } = await post("/data/occupations/videos", { "occupations": occupations });

    dispatch({type: SET_RESOURCES, data: data, orderDict: occupations, categoryKey: categoryKey});
    dispatch({type: LOADING_RESOURCES, loading: false});


    } catch (error) {
        console.log(error);
        // TODO
    }

    
}

const unAuthenticatedVideos = {
    "UnAuth": {
        "paths": ["/login", "/signup", "/forgot"],
        "videos": [
            {
                "id": "3pELYBz2wm1fzam5uwfkEG",
                "title": "Login"
            },
            {
                "id": "95i2ZqodvxAVQkmNpQo9AD",
                "title": "Sign up"
            },
            {
                "id": "u1rYcgab18ZTtTj6ZzJVrx",
                "title": "Forgot Password"
            },
            {
                "id": "xfCXC2pYpamcFdXL8qthvE",
                "title": "Invite"
            }
        ]
    }
}

export const getHelpVideos = (path) => async (dispatch, getState) => {
    const {
        auth:{authenticated = false}, 
        user:{rawdata:{internalMobilityProvider}={}},
        resources: {authenticatedVideos}
    } = getState();
    if(authenticated){
        let videos = authenticatedVideos ? authenticatedVideos : []
        if(!authenticatedVideos){
            const data = await get(`/helpvideo`);
            if (data.success) {
                videos = data.data;
                dispatch({ type: SET_HELP_VIDEOS, data: data.data });
            }
        }
        const pathData = Object.values(videos).find((value) => value.paths.includes(path))
        if(pathData){
            return {...pathData, videos: pathData.videos.filter((item) => !item.role || (item.role && ((item.role === "candidiate" && !internalMobilityProvider) || (item.role === "employee" && internalMobilityProvider))))}                
        }
    }
    else{
        return Object.values(unAuthenticatedVideos).find((value) => value.paths.includes(path))
    }
    
}

export const getSkillAssessment = (skillName) => async (dispatch, getState) => {
    const { user:{ completedSkillAssessments={} }} = getState()
    try{
        if(!skillName){
            dispatch({type: SET_SKILLS_ASSESSMENTS, "data": false})
            return
        }
        let version = 1
        if(completedSkillAssessments && completedSkillAssessments[skillName]){
            version = completedSkillAssessments[skillName].length + 1
        }

        const { data, success } = await post("/data/skills/assessment", { "skill": skillName, "assessment_version": version });

        if (success) {
            if (data.questions && data.questions.length > 0) {
                dispatch({type: SET_SKILLS_ASSESSMENTS, "data": data});
            } else {
                dispatch({type: SET_SKILLS_ASSESSMENTS, "data": false})
            }
        }
        else{
            dispatch({type: SET_SKILLS_ASSESSMENTS_ERRORS, "data": [skillName]})    
        }
    } catch (error) {
        dispatch({type: SET_SKILLS_ASSESSMENTS_ERRORS, "data": [skillName]})
        console.log(error);
        // TODO
    }
}

export const submitSkillsAssessmentReport = (data) => async (dispatch, getState) => {
    try{
        await post("/data/skills/assessmentError", data);
    } catch (error) {
        console.log(error);
        // TODO
    }
}

export function fetchSkillTypes(skills = []) {
  return async function(dispatch, getState) {
    try {
      if(skills && skills.length){
        const data = await post("/data/skills/types", { skills: skills });

        if (data) {
          dispatch({ type: FETCH_SKILL_TYPES, data: data && data.data ? data.data : {} }); // eslint-disable-line
        }
        else{
          dispatch({ type: FETCH_SKILL_TYPES, data: {} });
        }
      }
    } catch (e) {
      dispatch({ type: FETCH_SKILL_TYPES, data: {} });
    }
  }
}

